<script setup>
import ExportButton from '@js/components/buttons/ExportButton.vue';
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import LinkCell from '@js/components/tables/cells/LinkCell.vue';
import TextCell from '@js/components/tables/cells/TextCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const {
    tenant,
    indexed = undefined,
    notIndexed = undefined,
} = defineProps({
    tenant: {
        required: true,
        type: Object,
    },
    indexed: {
        required: false,
        type: Boolean,
    },
    notIndexed: {
        required: false,
        type: Boolean,
    },
});

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    setGlobalFilter,
    availableFilters,
    filters,
    setFilters,
    selectionIds,
    exportData,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'seoIndexationSitemaps.name',
            header: () => 'Sitemap',
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.seoIndexationSitemap.name,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'seoIndexationUrls.url',
            header: () => 'URL',
            cell: (props) =>
                h(LinkCell, {
                    text: props.row.original.url,
                    href: props.row.original.url,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'coverageStateId',
            header: () => 'Statut',
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.googleSearchConsoleCoverageState
                        .translatedLabel,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'indexedAt',
            header: () => 'Indexé le',
            cell: (props) =>
                props.row.original.indexedAt
                    ? h(TextCell, {
                          text: props.row.original.indexedAt,
                      })
                    : undefined,
        }),
        columnHelper.accessor(() => null, {
            id: 'notIndexedAt',
            header: () => 'Désindexé le',
            cell: (props) =>
                props.row.original.notIndexedAt
                    ? h(TextCell, {
                          text: props.row.original.notIndexedAt,
                      })
                    : undefined,
        }),
        columnHelper.accessor(() => null, {
            id: 'updatedAt',
            header: () => 'MÀJ le',
            cell: (props) =>
                h(TextCell, {
                    text: props.row.original.updatedAt,
                }),
        }),
    ],
    url: route('front.projectManagement.seo.postIndexationUrls', {
        tenant: tenant.id,
    }),
    exportUrl: route('front.projectManagement.seo.postExportIndexationUrls', {
        tenant: tenant.id,
    }),
    data: {
        indexed,
        notIndexed,
    },
    selectionIdKey: 'id',
    exportSelectionIdKey: 'seoIndexationUrls.id',
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :set-global-filter="setGlobalFilter"
        :available-filters="availableFilters"
        :filters="filters"
        :set-filters="setFilters"
        :loading="loading"
    >
        <template #actions>
            <ExportButton
                :csv-export-callback="() => exportData('csv')"
                :xlsx-export-callback="() => exportData('xlsx')"
                :disabled="selectionIds.length === 0"
            />
        </template>
    </DataTableLayout>
</template>
